"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var user_hook_1 = require("../../../../context/UserContext/user.hook");
var general_1 = require("../../../../lib/general");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var country_hook_1 = require("../../../../context/CountryContext/country.hook");
var GuideTable = function (props) {
    var header = [
        "icon",
        "title",
        "sorting_order",
        "thumbnail",
        "video",
        // "edit",
        // "delete",
    ], _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n, currentLang = i18n.language;
    var _b = (0, react_1.useState)([]), tableFields = _b[0], setTableFields = _b[1], organization = (0, org_hook_1.useOrg)().organization, user = (0, user_hook_1.useUser)().user, country = (0, country_hook_1.useCountry)().country, _c = (0, react_1.useState)(null), click = _c[0], setClick = _c[1];
    (0, react_1.useEffect)(function () {
        setTableFields(props.list);
    }, [props.list]);
    var renderTableHeader = function () {
        return header.map(function (item, key) { return (react_1.default.createElement("th", { className: "cell", key: key, style: {
                backgroundColor: "#DC8006",
                color: "white",
            } }, t(item))); });
    }, column = function (l, i) { return (react_1.default.createElement("tr", { key: i },
        react_1.default.createElement("td", { className: "cell", colSpan: 8, onClick: function () {
                if (click === l.id) {
                    setClick(null);
                }
                else {
                    setClick(l.id);
                }
            }, style: click === l.id
                ? { background: "#c8e0ec" }
                : { background: "#ffffff" } },
            react_1.default.createElement("div", { className: "heading", style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin: "1.9vh 0px",
                } },
                react_1.default.createElement("div", { className: "col", style: click === l.id
                        ? {
                            transform: "rotate(270deg)",
                            transition: "transform 500ms ease 0s",
                        }
                        : {
                            transform: "rotate(90deg)",
                            transition: "transform 500ms ease 0s",
                        } },
                    react_1.default.createElement(icons_1.default, { className: "icon_black", height: 30, name: "backArrow", width: 30 })),
                react_1.default.createElement("div", { className: "col" },
                    react_1.default.createElement("div", { className: "category-image-container " }, l.icon !== "" ? (react_1.default.createElement("img", { className: "category-image", src: (0, general_1.generateMediaLink)(l.icon, organization === null || organization === void 0 ? void 0 : organization.id, 
                        // user?.detail?.address_country,
                        country) })) : (react_1.default.createElement("div", { className: "category-no-image" })))),
                react_1.default.createElement("div", { className: "col", style: {
                        color: "#2a4848",
                        fontSize: "14px",
                        fontWeight: "bold",
                        fontFamily: "Montserrat",
                    } }, (0, general_1.isJsonWithAvailableLang)(l.name, currentLang.toLowerCase(), t)))))); }, renderBody = function () { return (react_1.default.createElement(react_1.default.Fragment, null, tableFields === null || tableFields === void 0 ? void 0 : tableFields.map(function (l, i) { return (react_1.default.createElement(react_1.Fragment, { key: i },
        column(l, i),
        react_1.default.createElement(react_1.default.Fragment, null, click === l.id &&
            l.guide &&
            l.guide.map(function (item, itemKey) {
                var _a, _b;
                var video_url = (0, general_1.generateMediaLink)((0, general_1.isJsonWithAvailableLang)((_a = item === null || item === void 0 ? void 0 : item.guide_media) === null || _a === void 0 ? void 0 : _a.video_link, currentLang, t), organization === null || organization === void 0 ? void 0 : organization.id, 
                // user?.detail?.address_country,
                country);
                var thumbnail_url = (0, general_1.generateMediaLink)((0, general_1.isJsonWithAvailableLang)((_b = item === null || item === void 0 ? void 0 : item.guide_media) === null || _b === void 0 ? void 0 : _b.thumbnail_link, currentLang, t), organization === null || organization === void 0 ? void 0 : organization.id, 
                // user?.detail?.address_country,
                country);
                return (react_1.default.createElement(react_1.Fragment, { key: itemKey },
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { colSpan: 2, className: "cell", "data-title": "title", style: {
                                textAlign: "left",
                            } }, (0, general_1.isJsonWithAvailableLang)(item.title, currentLang.toLowerCase(), t)),
                        react_1.default.createElement("td", { className: "cell", "data-title": "sorting" }, item.sorting),
                        react_1.default.createElement("td", { className: "cell", "data-title": "thumbnail_link" },
                            react_1.default.createElement("a", { onClick: function () { return window.open(thumbnail_url, "_blank"); } }, thumbnail_url !== null ? (react_1.default.createElement("img", { src: "".concat(thumbnail_url), width: 100 })) : (""))),
                        react_1.default.createElement("td", { className: "cell", "data-title": "guide_media" },
                            react_1.default.createElement("a", { onClick: function () { return window.open(video_url, "_blank"); } }, video_url !== null ? (react_1.default.createElement("video", { width: "200", height: "160", controls: true, src: "".concat(video_url) })) : ("")))),
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { "data-title": "description", className: "cell", colSpan: 8 },
                            react_1.default.createElement("a", { style: {
                                    fontWeight: "bolder",
                                } }, (0, general_1.isJsonWithAvailableLang)(item.description, currentLang.toLowerCase(), t))))));
            })))); }))); };
    return (react_1.default.createElement("div", { className: "tableListContainer" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("table", { className: "tableView" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, renderTableHeader())),
                react_1.default.createElement("tbody", null, renderBody())))));
};
exports.default = GuideTable;
